import React from 'react'
import ErrorIcon from '@mui/icons-material/Error'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Portal, Snackbar } from '@mui/material'
import { Alert, AlertProps } from '@mui/material'

import { useBreakpoint } from '../../../providers/BreakpointProvider'
import useStyles from './styles'

export interface ToastProps {
  autoHideDuration?: number
  severity?: AlertProps['severity']
  resetError?: () => void
  children?: React.ReactNode
}

const Toast: React.FC<ToastProps> = ({
  autoHideDuration = 2500,
  severity,
  resetError,
  children
}) => {
  const { isMedium } = useBreakpoint()

  const [open, setOpen] = React.useState(false)

  const classes = useStyles({ onMobile: isMedium })

  React.useEffect(() => {
    setOpen(Boolean(children))
  }, [children])

  const handleClose = React.useCallback(
    (e, reason) => {
      if (reason === 'clickaway') {
        return
      }

      setOpen(false)
      resetError && resetError()
    },
    [resetError]
  )

  return (
    <Portal>
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={autoHideDuration}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        classes={{ root: classes.root }}
      >
        <Alert
          severity={severity}
          variant='filled'
          onClose={() => handleClose(null, null)}
          className={classes.alert}
          action={<></>}
          iconMapping={{
            error: <ErrorIcon fontSize='inherit' />,
            success: <CheckCircleIcon fontSize='inherit' />
          }}
        >
          {children}
        </Alert>
      </Snackbar>
    </Portal>
  )
}

export default Toast
